import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

interface CreateFamilyFolderApiCallParams {
    home: string;
}

export class CreateFamilyFolderApiCall extends APICallV4<CreateFamilyFolderApiCallParams | null> {
    _method = 'family/folder/share';
    _type: Method = 'post';
    _retriesCount = 0;
}
